import React from 'react'
import { OnBoardingContentImage } from '../../../../components/Onboard/OnBoardingContentImage'
import measurementFilter from './img/measurement-filter.gif'
import dieSetFilter from './img/die-set-filter.gif'
import categoryFilter from './img/category-filter.gif'

export const steps = [
  {
    target: '[data-joyridestep="filter_shape"]',
    title: 'Click a button to filter by shape type. ',
    placement: 'right-start',

    spotlightClicks: true,
  },
  {
    target: '[data-joyridestep="filter_shape_clear"]',
    text: <>This button will clear the applied filter.</>,
    title: 'Clear filter',
    placement: 'right-start',
  },
  {
    target: '[data-joyridestep="filter_measurement"]',
    text: (
      <>
        <OnBoardingContentImage src={measurementFilter} />
        <div> You can filter the products by size. Just specify the measurement whether millimeter or inches.</div>
      </>
    ),

    title: 'Vertical and Horizontal filter',
    tip: (
      <>
        It is useful to filter by shapes then by size. If RECTANGLE shape, put both the vertical/diameter and
        horizontal/over flat filter values. If square or circle, put only the vertical/diameter values{' '}
      </>
    ),
    placement: 'right-start',
  },
  {
    target: '[data-joyridestep="filter_dieSetType"]',
    text: (
      <>
        <OnBoardingContentImage src={dieSetFilter} />
        <div> Filter the products by type. You can choose multiple types by checking the boxes.</div>
      </>
    ),
    title: 'Die set type filter',
    placement: 'right-start',
  },
  {
    target: '[data-joyridestep="filter_category"]',
    text: (
      <>
        <OnBoardingContentImage src={categoryFilter} />
        <div>Choose between categories to filter accordingly.</div>
      </>
    ),

    title: 'Category filter',
    placement: 'right-start',
  },
  {
    target: '[data-joyridestep="filter_clear"]',
    text: (
      <div>Click this button to clear all the filters applied. It will show all the available products by default.</div>
    ),

    title: 'Clear all filter',
    placement: 'right-start',
  },
]
